import { Search, User, Globe, Calendar, Info, Tag } from "lucide-react";
import { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import ProtectDashboardRoute from "../components/ProtectDashboardRoute";

export default function MyNumbersDashboard() {
  const [myNumbers] = useState([
    {
      id: 1,
      number: "+234 701 234 5678",
      country: "Nigeria",
      countryCode: "NG",
      date: "2025-08-20",
      status: "Active",
      usage: "WhatsApp Verification",
      price: "₦15,200",
    },
    {
      id: 2,
      number: "+1 202 555 0147",
      country: "USA",
      countryCode: "US",
      date: "2025-08-15",
      status: "Expired",
      usage: "Telegram Verification",
      price: "₦28,900",
    },
    {
      id: 3,
      number: "+44 7700 900123",
      country: "UK",
      countryCode: "GB",
      date: "2025-07-30",
      status: "Active",
      usage: "Facebook Verification",
      price: "₦11,200",
    },
  ]);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <ProtectDashboardRoute />
      {/* Sidebar (reused) */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white shadow px-6 py-4 flex justify-between items-center">
          {/* Search */}
          <div className="flex items-center bg-gray-100 rounded-lg px-3 py-2 w-1/3">
            <Search className="w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search numbers..."
              className="bg-transparent outline-none px-2 w-full text-gray-700"
            />
          </div>

          {/* User Info */}
          <div className="flex items-center gap-4">
            <p className="text-gray-700 font-medium">
              Welcome back, <span className="font-bold">Teecodes</span>
            </p>
            <User className="w-8 h-8 text-gray-600 border rounded-full p-1" />
          </div>
        </header>

        {/* Page Content */}
        <main className="p-8 flex-1">
          {/* Title */}
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800">My Numbers</h1>
            <Link
              to="/dashboard/buy/numbers"
              className="bg-[#007AFF] text-white px-6 py-2 rounded-lg shadow hover:bg-[#005FCC] transition inline-block"
            >
              Buy New Number
            </Link>
          </div>

          {/* Table */}
          <div className="bg-white rounded-2xl shadow overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="py-4 px-6">Number</th>
                  <th className="py-4 px-6">Country</th>
                  <th className="py-4 px-6">Date Purchased</th>
                  <th className="py-4 px-6">Status</th>
                  <th className="py-4 px-6">Usage</th>
                  <th className="py-4 px-6">Price</th>
                  <th className="py-4 px-6">Details</th>
                </tr>
              </thead>
              <tbody>
                {myNumbers.map((num) => (
                  <tr
                    key={num.id}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <td className="py-4 px-6">{num.number}</td>

                    {/* Country with Flag */}
                    <td className="py-4 px-6 flex items-center gap-2">
                      <ReactCountryFlag
                        countryCode={num.countryCode}
                        svg
                        style={{
                          width: "1.5em",
                          height: "1.5em",
                          borderRadius: "4px",
                        }}
                      />
                      {num.country}
                    </td>

                    {/* Date */}
                    <td className="py-4 px-6 flex items-center gap-2">
                      <Calendar className="w-5 h-5 text-gray-500" />
                      {num.date}
                    </td>

                    {/* Status */}
                    <td className="py-4 px-6">
                      <span
                        className={`px-3 py-1 rounded-full text-sm font-medium ${
                          num.status === "Active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {num.status}
                      </span>
                    </td>

                    {/* Usage */}
                    <td className="py-4 px-6">{num.usage}</td>

                    {/* Price */}
                    <td className="py-4 px-6 font-bold text-gray-800 flex items-center gap-2 text-lg">
                      <Tag className="w-5 h-5 text-[#007AFF]" />
                      {num.price}
                    </td>

                    {/* Details */}
                    <td className="py-4 px-6">
                      <button className="flex items-center gap-1 text-[#007AFF] hover:underline">
                        <Info className="w-4 h-4" />
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
}
